// API Configuration
const API_CONFIG = {
  // Get the base URL based on environment
  getBaseUrl: () => {
    // In production, use the current hostname
    if (process.env.NODE_ENV === 'production') {
      // Use the current origin for API requests
      return window.location.origin;
    }
    // In development, always use the backend server port
    return 'http://localhost:5000';
  },

  // Get the full URL for an endpoint
  getUrl: (endpoint) => {
    const baseUrl = API_CONFIG.getBaseUrl();
    // Remove leading slash if present to avoid double slashes
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    // Ensure we're using the correct API path
    const apiPath = cleanEndpoint.startsWith('api/') ? cleanEndpoint : `api/${cleanEndpoint}`;
    return `${baseUrl}/${apiPath}`;
  }
};

export default API_CONFIG; 